import React, { useState } from 'react';
import useFetchData from "repo/get";
import DataTablePontos from "./TableWorkerHours";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog"; 

const CardPontos = () => {
  const [error] = useState(null);
  const [selectedDeliverer, setSelectedDeliverer] = useState(null);
  const [isDialogVisible, setIsDialogVisible] = useState(false); 
  const { data, loading } = useFetchData("api/motoristas/findAll");

  if (error) {
    return <p>{error}</p>;
  }

  if (loading) {
    return <p>Carregando...</p>;
  }

  const deliverers = Array.isArray(data) ? data.filter(deliverer => deliverer.frete !== true) : [];

  const handleShowDetails = (id) => {
    setSelectedDeliverer(id);
    setIsDialogVisible(true); 
  };

  const handleCloseDialog = () => {
    setIsDialogVisible(false); 
    setSelectedDeliverer(null);
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <div className="p-6 pb-0 mb-0 border-b-0 border-b-solid rounded-t-2xl border-b-transparent">
        <h1 className="text-2xl font-bold text-blueGray-700">Lista de Motoristas</h1>
      </div>
      <div className="flex-auto px-0 pt-0 pb-2">
        <div className="p-0 overflow-x-auto">
          <table className="items-center w-full mb-0 align-top border-collapse dark:border-white/40 text-slate-500">
            <thead className="align-bottom">
              <tr>
                <th className="px-6 py-3 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Funcionário
                </th>
                <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Função
                </th>
                <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {deliverers.length > 0 ? (

                deliverers.sort((a, b) => a.nome.localeCompare(b.nome))
                .map((deliverer, index) => (
              
                  <React.Fragment key={index}>
                    <tr>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        <div className="flex px-2 py-1">
                          <div className="mr-2 flex h-8 w-8 items-center justify-center rounded-lg bg-center stroke-0 text-center xl:p-2.5">
                            <i className="relative top-0 text-sm leading-normal text-slate-700 ni ni-single-02"></i>
                          </div>
                          <div className="flex flex-col justify-center">
                            <h6 className="mb-0 text-sm leading-normal dark:text-white font-semibold">
                              {deliverer.nome}
                            </h6>
                            <p className="mb-0 text-xs leading-tight dark:text-white dark:opacity-80 text-slate-400">
                              {deliverer.telefone ? deliverer.telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : "Localização desconhecida"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        <p className="mb-0 text-xs font-semibold leading-tight dark:text-white dark:opacity-80">
                          Motorista
                        </p>
                        <p className="mb-0 text-xs leading-tight dark:text-white dark:opacity-80 text-slate-400">
                          {deliverer.base?.[0]?.nome || "Localização desconhecida"}
                        </p>
                      </td>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        <Button
                          label="Horas"
                          icon="pi pi-clock"
                          onClick={() => handleShowDetails(deliverer)}
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 px-3 py-1 rounded-md shadow  font-bold"
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">Nenhum entregador encontrado</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isDialogVisible && ( 
        <Dialog header={`Tabela de Pontos de ${selectedDeliverer ? selectedDeliverer.nome : 'Carregando...'}`} 
        visible={isDialogVisible} onHide={handleCloseDialog} style={{ width: "80%" }}> 
          <DataTablePontos id={selectedDeliverer} />
        </Dialog>
      )}
    </div>
  );
};

export default CardPontos;
